import React from 'react' 
import './popular.css'
import data_product from '../Assets/data' 
import Item from '../Items/Item'

const Popular = () => {
  return (
    <div className="popular">

<h1>RECENTLY ADDED </h1><hr /> 
    <div className="recentItems">
    
    {data_product.map((item,i)=>{ 
        return <Item key={i} id={item.id}  name={item.name} info={item.info} image={item.image}  newPrice={item.newPrice}  oldPrice={item.oldPrice}/>
    
    })}
    
</div>


<br />

      </div>


)
}

export default Popular